import { useState } from 'react';
import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/siteData';

const SUBSCRIBE_URL = 'https://readdy.ai/api/form/d95mu3ea5sk3luk4pghg';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMsg, setStatusMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('company_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setStatusMsg('订阅成功！感谢你的关注 🍉');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const payload = new URLSearchParams();
      payload.append('email', email);
      formData.forEach((value, key) => {
        if (key !== 'company_alt') payload.append(key, value as string);
      });

      const res = await fetch(SUBSCRIBE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setStatusMsg('订阅成功！感谢你的关注 🍉');
        setEmail('');
      } else {
        setStatus('error');
        setStatusMsg(parsed?.meta?.message || '订阅失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setStatusMsg('网络错误，请检查网络后重试');
    } finally {
      setTimeout(() => setStatus('idle'), 4000);
    }
  };

  return (
    <footer className="bg-foreground-950 text-background-50 rounded-2xl mx-4 md:mx-8 mb-6 md:mb-8 overflow-hidden">
      <div className="px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-5">
              <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-chat-smile-2-line text-xl text-foreground-950"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50">91吃瓜社区</span>
            </div>
            <p className="text-foreground-300 text-sm leading-relaxed mb-8 max-w-sm">
              全网最大的吃瓜群众聚集地。每天为你精选最新最热的八卦爆料，让你不错过任何一个大瓜。黑料正能量不打烊，欢迎回家一起吃瓜。
            </p>
            <p className="text-foreground-400 text-xs font-medium mb-3">订阅每日爆料推送</p>
            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3 max-w-md" data-readdy-form>
              <div className="website_alt_field">
                <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <input
                type="email"
                name="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入你的邮箱地址"
                className="flex-1 bg-foreground-900/50 border border-foreground-700/30 rounded-full px-5 py-3 text-sm text-background-50 placeholder-foreground-400 focus:outline-none focus:border-accent-500/50 transition-colors"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="px-6 py-3 bg-background-50 text-foreground-950 rounded-full text-sm font-medium hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer disabled:opacity-50"
              >
                {status === 'loading' ? '提交中...' : '立即订阅'}
                <i className="ri-arrow-right-line ml-1.5"></i>
              </button>
            </form>
            {status !== 'idle' && (
              <p className={`text-xs mt-3 ${status === 'success' ? 'text-accent-400' : 'text-primary-400'}`}>
                {statusMsg}
              </p>
            )}
          </div>

          <div className="md:col-span-2">
            <h4 className="text-background-50 text-sm font-semibold mb-4 font-heading">探索</h4>
            <ul className="space-y-3">
              {footerLinks.explore.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-foreground-300 text-sm hover:text-background-50 transition-colors underline decoration-foreground-600/30 hover:decoration-foreground-200 cursor-pointer">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-background-50 text-sm font-semibold mb-4 font-heading">关于</h4>
            <ul className="space-y-3">
              {footerLinks.about.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-foreground-300 text-sm hover:text-background-50 transition-colors underline decoration-foreground-600/30 hover:decoration-foreground-200 cursor-pointer">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-background-50 text-sm font-semibold mb-4 font-heading">支持</h4>
            <ul className="space-y-3">
              {footerLinks.support.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-foreground-300 text-sm hover:text-background-50 transition-colors underline decoration-foreground-600/30 hover:decoration-foreground-200 cursor-pointer">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <a href="https://weibo.com" target="_blank" rel="nofollow noopener" className="text-foreground-400 hover:text-background-50 transition-colors text-sm underline decoration-foreground-600/30">
              微博
            </a>
            <a href="https://www.douyin.com" target="_blank" rel="nofollow noopener" className="text-foreground-400 hover:text-background-50 transition-colors text-sm underline decoration-foreground-600/30">
              抖音
            </a>
            <a href="https://www.xiaohongshu.com" target="_blank" rel="nofollow noopener" className="text-foreground-400 hover:text-background-50 transition-colors text-sm underline decoration-foreground-600/30">
              小红书
            </a>
          </div>
          <p className="text-foreground-500 text-xs">© 2026 91吃瓜社区 版权所有</p>
          <div className="flex items-center gap-6">
            <Link to="/about#privacy" className="text-foreground-400 hover:text-background-50 transition-colors text-sm underline decoration-foreground-600/30">
              隐私政策
            </Link>
            <Link to="/about#terms" className="text-foreground-400 hover:text-background-50 transition-colors text-sm underline decoration-foreground-600/30">
              用户协议
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}